<div class="kfm-article-create-edit-dialog" [hsLayer]="'one'">
  <hs-form-field>
    <hs-form-label>{{ shortTextLabel }}</hs-form-label>
    <input
      #titleInput
      hsInput
      [placeholder]="shortTextLabel"
      [value]="title()"
      (input)="onTitleChanged(titleInput.value)"
    />
  </hs-form-field>

  <hs-form-field>
    <hs-form-label>{{ manufacturerLabel }}</hs-form-label>
    <input
      #manufacturerInput
      hsInput
      [placeholder]="manufacturerLabel"
      [value]="manufacturer()"
      (input)="onManufacturerChanged(manufacturerInput.value)"
    />
  </hs-form-field>

  <hs-form-field>
    <hs-form-label>{{ articleNumberLabel }}</hs-form-label>
    <input
      #articleNumberInput
      hsInput
      [placeholder]="articleNumberLabel"
      [value]="articleNumber()"
      (input)="onArticleNumberChanged(articleNumberInput.value)"
    />
  </hs-form-field>

  <div class="flex flex-row gap-2">
    @if (showAmount) {
      <hs-form-field class="w-1/2">
        <hs-form-label>{{ quantityLabel }}</hs-form-label>
        <input
          #amountInput
          hsInput
          type="number"
          [placeholder]="quantityLabel"
          [value]="amount()"
          (input)="onAmountChanged(amountInput.value)"
        />
      </hs-form-field>
    }

    <hs-form-field class="w-1/2" [class.w-full]="!showAmount">
      <hs-form-label>{{ unitLabel }}</hs-form-label>
      <input
        #unitInput
        hsInput
        [placeholder]="unitLabel"
        [value]="unit()"
        (input)="onUnitChanged(unitInput.value)"
      />
    </hs-form-field>
  </div>

  <div class="flex flex-row gap-2 items-end">
    <hs-form-field class="flex-1">
      <hs-form-label>{{ netLabel }}</hs-form-label>
      <input
        #netInput
        hsInput
        type="number"
        [placeholder]="netLabel"
        [value]="netTotal()"
        (input)="onNetTotalChanged(netInput.value)"
      />
    </hs-form-field>

    <hs-form-field class="flex-1">
      <hs-form-label>{{ vatLabel }}</hs-form-label>
      <hs-select
        [options]="articleMwstOptions"
        [selectedValue]="mwstAsOption()"
        (selectionChanged)="onSelectionChanged($event, 'mwst')"
      ></hs-select>
    </hs-form-field>

    <hs-form-field class="flex-1">
      <hs-form-label>{{ grossLabel }}</hs-form-label>
      <input
        #grossInput
        hsInput
        type="number"
        [placeholder]="grossLabel"
        [value]="grossTotal()"
        (input)="onGrossTotalChanged(grossInput.value)"
      />
    </hs-form-field>
  </div>

  <div class="flex flex-row w-full justify-end gap-2 p-2">
    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="outlined"
      (click)="dialogRef.close()"
    >
      {{ cancelLabel }}
    </button>

    <button
      hsButton
      hsButtonSize="sm"
      hsButtonVariant="filled"
      (click)="dialogRef.close(selectedArticle())"
      [disabled]="!canSave"
    >
      {{ okLabel }}
    </button>
  </div>
</div>
